export const producTypesdb = [
    { id: 1076, value: '01', label: 'Producto' },
    { id:1077, value: '02', label: 'Servicio' },

]